import { ActionType } from 'src/interfaces/action.interface';
import { isValidPhoneNumber } from 'libphonenumber-js';

export function getTelephonyProviderType(
  accountConnectionType: string,
): string {
  switch (accountConnectionType) {
    case 'account_connection_twilio':
      return 'twilio';
    case 'account_connection_telnyx':
      return 'telnyx';
    default:
      throw new Error(
        `account_connection_type=${accountConnectionType} is not a telephony account connection`,
      );
  }
}

export function getAccountConnectionType(telephonyProvider: string): string {
  switch (telephonyProvider) {
    case 'twilio':
      return 'account_connection_twilio';
    case 'telnyx':
      return 'account_connection_telnyx';
    default:
      throw new Error(
        `telephonyProvider=${telephonyProvider} is not a telephony provider`,
      );
  }
}

/**
 * Validates a phone number for action forms, including special handling for WarmTransfer.
 * @param {ActionType} actionType - The type of the action (e.g., WarmTransfer).
 * @param {string} value - The phone number value to validate.
 * @returns {{ isValid: boolean; error: string | null }}
 */
export function validateActionPhoneNumber(
  actionType: ActionType,
  value: string,
): { isValid: boolean; error: string | null } {
  const isWarm =
    (actionType === ActionType.WarmTransfer ||
      actionType === ActionType.TransferCall) &&
    String(value).trim().toLowerCase() === 'warm';

  const raw = String(value).trim();
  // Remove all non-digit characters except leading +
  let cleaned = raw.replace(/[^\d+]/g, '');

  // If it starts with +, keep as is, else clean to digits only
  if (!cleaned.startsWith('+')) {
    cleaned = cleaned.replace(/\D/g, '');
  }

  let formattedNumber = cleaned;
  // Allow US numbers without country code for TransferCall and WarmTransfer
  if (
    (actionType === ActionType.WarmTransfer ||
      actionType === ActionType.TransferCall) &&
    /^\d{10}$/.test(formattedNumber)
  ) {
    formattedNumber = `+1${formattedNumber}`;
  } else if (!formattedNumber.startsWith('+')) {
    formattedNumber = `+${formattedNumber}`;
  }

  if (!isWarm && !isValidPhoneNumber(formattedNumber)) {
    return { isValid: false, error: 'Invalid phone number.' };
  }
  return { isValid: true, error: null };
}
